import { IMoveToProjectParams } from '../types/IMoveToProjectParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class MovePublishedConnectionsToProject extends Request<IMoveToProjectParams, IResult> {
  constructor(params: IMoveToProjectParams) {
    super('movePublishedConnectionsToProject', params);
  }
}
